import React from "react";

import {
  CenterContainer,
  VBox,
  Image,
  TextureRect,
} from "@liro_u/react-components";

const DefaultProject = ({
  title = "Default Title",
  description = "this is the default description of the template default project, it is auto generate when we create a React component of this type but it will appear only when we use it without the cms",
  image = "https://placehold.co/600x400",
  backgroundTexture = "https://act.hoyoverse.com/puzzle/upload/puzzle/2023/05/05/08b3818ec98faf6f7cd5333f87e35ba1_6642213308727446849.png?x-oss-process=image/format,webp/quality,Q_90",
}) => {
  return (
    <div className="defaultProject">
      <TextureRect
        texture={backgroundTexture}
        style={{
          minHeight: "100vh",
        }}
      >
        <CenterContainer>
          <VBox
            style={{
              width: "800px",
            }}
          >
            <h1>{title}</h1>
            <p>{description}</p>
            <Image src={image} width="600px" height="400px" />
          </VBox>
        </CenterContainer>
      </TextureRect>
    </div>
  );
};

export default DefaultProject;
